<template>
  <div class="flex mt-30">
    <div class="h-8rem border-r px-6rem pt-6 space-y-4 text-left">
      <p class="text-base">
        <span class="iconfont icon-youxiang"></span>
        <span class="pl-3">{{ $t("邮箱") }}：global@huaeb.com</span>
      </p>
      <div class="text-base">
        <p class="whitespace-nowrap">
          <span class="iconfont icon-dianhua"></span>
          <span class="pl-3">{{ $t("电话") }}：</span>
          <span class="text-xl font-medium">138 8894 1419</span>
          <span> {{ $t("或") }}</span>
          <span class="text-xl font-medium pl-2">184 8884 8860</span>
        </p>
        <p class="pl-19 text-gray-400">08:00-08:00（{{ $t("24小时热线") }}）</p>
      </div>
      <div class="flex items-center">
        <p class="w-7rem flex">
          <i class="iconfont icon-weixin1"></i>
          WeChat
        </p>
        <img class="container w-28 mr-6"
          src="https://cdn-qn.huaeb.com/sellmall/Xhd/20251118/Fp589CKie-zWAO5ldNDL69XlY-R9.jpg!normal" alt="" />
        <img class="container w-28"
          src="https://cdn-qn.huaeb.com/sellmall/Xhd/20251118/Flf9zQ36AJ3uuHmq2POPCxYSTW4J.jpg!normal" alt="" />
      </div>
      <div class="flex items-center">
        <p class="w-7rem flex">
          <i class="iconfont icon-dianhua1"></i>
          WhatsAPP
        </p>
        <img class="container w-28"
          src="https://cdn-qn.huaeb.com/sellmall/Xhd/20251118/Fi5y_sPt0Lss94oBYUO-_Tb5qs0X.jpg!normal" alt="" />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-20 pl-4">

      <div>
        <img class="container w-28"
          src="https://cdn-qn.huaeb.com/sellmall/20210830/FhWbKfZFkLUCtWPcXcQHKd-wc8fg.png!normal" alt="" />
        {{ $t("关注我们") }}
      </div>
      <div>
        <img class="container w-28"
          src="https://irutils.inruan.com/utils/qrcode?text=https://int.huaeb.com/app/download.html&logo=https://cdn-qn.huaeb.com/sellmall/X1/20230608/FmmQ5J4Pfc0qqqFeuuWDfYI4He25.png!normal"
          alt="" />
        {{ $t("APP下载") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>